import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import Account from '@pages/Account';
import Group from '@pages/Group';
import GroupDetail from '@pages/Group/pages';
import GroupEdit from '@pages/Group/pages/Edit';
import GroupNew from '@pages/Group/pages/New';
import PortfolioEdit from '@pages/Group/pages/Portfolio/Edit';
import PortfolioNew from '@pages/Group/pages/Portfolio/New';
import Portfolio from '@pages/Group/pages/Portfolio/pages';
import BasicInfo from '@pages/Group/pages/Portfolio/pages/BasicInfo';
import CapitalChange from '@pages/Group/pages/Portfolio/pages/CapitalChange';
import Cashflow from '@pages/Group/pages/Portfolio/pages/Cashflow';
import Customer from '@pages/Group/pages/Portfolio/pages/Customer';
import Finance from '@pages/Group/pages/Portfolio/pages/Finance';
import GrowthInfo from '@pages/Group/pages/Portfolio/pages/GrowthInfo';
import InvestAsset from '@pages/Group/pages/Portfolio/pages/InvestAsset';
import InvestHistory from '@pages/Group/pages/Portfolio/pages/InvestHistory';
import PostManagement from '@pages/Group/pages/Portfolio/pages/PostManagement';
import PostManagementDetail from '@pages/Group/pages/Portfolio/pages/PostManagement/pages/Detail';
import PostManagementEdit from '@pages/Group/pages/Portfolio/pages/PostManagement/pages/Edit';
import PostManagementNew from '@pages/Group/pages/Portfolio/pages/PostManagement/pages/New';
import Press from '@pages/Group/pages/Portfolio/pages/Press';
import Stockholder from '@pages/Group/pages/Portfolio/pages/Stockholder';
import StockholderEdit from '@pages/Group/pages/Portfolio/pages/Stockholder/pages/Edit';
import StockholderNew from '@pages/Group/pages/Portfolio/pages/Stockholder/pages/New';
import Home from '@pages/Home';
import Report from '@pages/Report';
import ReportDetail from '@pages/Report/pages/Detail';
import ReportNew from '@pages/Report/pages/New';

const CompanyRoute = () => {
  return (
    <>
      <Route path="/home" element={<Home />} />
      <Route path="/group" element={<Group />} />
      <Route path="/group/new" element={<GroupNew />} />
      <Route path="/group/edit/:groupId" element={<GroupEdit />} />
      <Route path="/group/:groupId" element={<GroupDetail />} />
      <Route path="/group/:groupId/portfolio/new" element={<PortfolioNew />} />
      <Route
        path="/group/:groupId/portfolio/:portfolioId/edit"
        element={<PortfolioEdit />}
      />
      <Route
        path="/group/:groupId/portfolio/:portfolioId"
        element={<Portfolio />}
      >
        <Route path="" element={<Navigate replace to="basic-info" />} />
        <Route path="basic-info" element={<BasicInfo />} />
        <Route path="invest-history" element={<InvestHistory />} />
        <Route path="stockholder" element={<Stockholder />} />
        <Route path="stockholder/new" element={<StockholderNew />} />
        <Route
          path="stockholder/edit/:stockholderId"
          element={<StockholderEdit />}
        />
        <Route path="capital-change" element={<CapitalChange />} />
        <Route path="cashflow" element={<Cashflow />} />
        <Route path="growth-info" element={<GrowthInfo />} />
        <Route path="customer" element={<Customer />} />
        <Route path="finance" element={<Finance />} />
        <Route path="invest-asset" element={<InvestAsset />} />
        <Route path="post-management" element={<PostManagement />} />
        <Route path="post-management/new" element={<PostManagementNew />} />
        <Route
          path="post-management/:postManagementId"
          element={<PostManagementDetail />}
        />
        <Route
          path="post-management/:postManagementId/edit"
          element={<PostManagementEdit />}
        />
        <Route path="press" element={<Press />} />
      </Route>
      <Route path="/account" element={<Account />} />
      <Route path="/report" element={<Report />} />
      <Route path="/report/new" element={<ReportNew />} />
      <Route path="/report/:reportId" element={<ReportDetail />} />
    </>
  );
};

export default CompanyRoute;
